import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Navigations } from "./AppRoutes";
import { Helmet } from "react-helmet";

const AppSeoProvider = () => {
  const location = useLocation();
  const [url, setUrl] = useState<string>(window.location.href);
  const [title, setTitle] = useState<string>("");

  useEffect(() => {
    const url = window.location.href;
    const pathName = window.location.pathname;

    setUrl(url);
    const matchedNav = Navigations.find((nav) => nav.href === pathName);
    setTitle(`${matchedNav?.name || ""}`);
  }, [location]);

  return (
    <>
      <Helmet>
        <title>PaveMark © AZ {title}</title>   
        <link rel="canonical" href={url} />
      </Helmet>
    </>
  );
};

export default AppSeoProvider;
